export function shouldClearMicSilent(opts: { muted: boolean; stillSilent: boolean }): boolean {
  return !opts.muted && !opts.stillSilent
}
